module.exports = __webpack_public_path__ + "static/media/santanderlogo.ab4c7e80.png";